/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './CalloutRendererStyles.scss';
const VARIANT_MAP = {
    info: 'default',
    warning: 'default',
    success: 'default',
    error: 'error',
    tip: 'default'
};
const ICON_MAP = {
    info: 'fa-light fa-circle-info',
    warning: 'fa-light fa-triangle-exclamation',
    success: 'fa-light fa-circle-check',
    error: 'fa-light fa-circle-xmark',
    tip: 'fa-light fa-lightbulb'
};
export function CalloutRenderer({ block }) {
    const callout = block;
    const icon = callout.icon || ICON_MAP[callout.variant];
    return (React.createElement(AIGeneralBlockCard, { variant: VARIANT_MAP[callout.variant], sections: [
            {
                label: callout.title,
                content: (React.createElement("div", { className: `qmb-ui-CalloutRenderer qmb-ui-CalloutRenderer--${callout.variant}` },
                    React.createElement("i", { className: `${icon} qmb-ui-CalloutRenderer__icon` }),
                    React.createElement(Text, { variant: "body" }, callout.content)))
            }
        ] }));
}
